const APIS = {
  STAFF: "/notificationservice/api/staff/",
  USER: "/notificationservice/api/user/",
  USER_PROFILE: "/notificationservice/api/user-profile/",
  CUSTOMER: "/notificationservice/api/customer/",
  NOTIFICATION: "/notificationservice/api/notification/",
  NOTICE: "/alertpopupservice/api/notice/",
};

export default APIS;
